module.exports = __webpack_public_path__ + "static/media/IMG_3915.6ea261b5.JPG";